import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudRaining = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 0.5C4.84453 0.5 3.83063 1.10308 3.2547 2.00988C1.71258 2.13468 0.5 3.42573 0.5 5C0.5 6.65685 1.84315 8 3.5 8H8.75C10.2688 8 11.5 6.76878 11.5 5.25C11.5 3.81741 10.4046 2.64067 9.00562 2.51172C8.51875 1.33132 7.357 0.5 6 0.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.18571 8.78565C4.4421 8.88821 4.56681 9.17919 4.46425 9.43558L3.96425 10.6856C3.86169 10.942 3.57071 11.0667 3.31432 10.9641C3.05792 10.8616 2.93322 10.5706 3.03577 10.3142L3.53577 9.06419C3.63833 8.8078 3.92931 8.68309 4.18571 8.78565Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.18571 8.78565C8.4421 8.88821 8.56681 9.17919 8.46425 9.43558L7.96425 10.6856C7.86169 10.942 7.57071 11.0667 7.31432 10.9641C7.05792 10.8616 6.93322 10.5706 7.03577 10.3142L7.53577 9.06419C7.63833 8.8078 7.92931 8.68309 8.18571 8.78565Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.46425 9.43558C6.56681 9.17919 6.4421 8.88821 6.18571 8.78565C5.92931 8.68309 5.63833 8.8078 5.53577 9.06419L5.03577 10.3142C4.93322 10.5706 5.05792 10.8616 5.31432 10.9641C5.57071 11.0667 5.86169 10.942 5.96425 10.6856L6.46425 9.43558Z",
			fill: "currentColor"
		})
	]
});
export default SvgCloudRaining;
